import { render, staticRenderFns } from "./airline_info.vue?vue&type=template&id=108886fa&scoped=true&"
import script from "./airline_info.vue?vue&type=script&lang=js&"
export * from "./airline_info.vue?vue&type=script&lang=js&"
import style0 from "./airline_info.vue?vue&type=style&index=0&id=108886fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108886fa",
  null
  
)

export default component.exports